/** @format */

import { Button, Grid, AppBar as MuiAppBar, useMediaQuery, Tooltip } from "@mui/material";
import { styled } from "@mui/material/styles";
import { Box } from "@mui/system";
import Search from "./Search";
import dayjs from 'dayjs';
import { useHistory } from "react-router-dom";
import HomeIcon from '@mui/icons-material/Home';
import FormManagerLogin from '../../components/FormManagerLogin/FormManagerLogin';
import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';
import Alert from '@mui/material/Alert';
import CheckIcon from '@mui/icons-material/Check';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { EventNote } from '@mui/icons-material';
import Typography from '@mui/material/Typography';
import LogoutIcon from '@mui/icons-material/Logout';
import { IsNullOrEmpty } from "../../helpers/Common";

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  backgroundColor: "transparent",
  height: "175px",

}));

const MobileAppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme }) => ({
  zIndex: theme.zIndex.drawer - 1,
  height: "100px",
  backgroundColor: "transparent",
}));




export default function Header({ open, timeout }) {
  const history = useHistory();
  const isMobile = useMediaQuery("(max-width:768px)");
  const isDesktop = !isMobile;
  const roles = localStorage.getItem("roles") ? localStorage.getItem("roles")?.split(",") : [];
  let defaultEventId = localStorage.getItem('defaultEventId') ?? '';
  const handleHome = () => {
    history.push("/");
  }

  return (
    <>
      <MobileAppBar
        position="fixed"
        open={open}
        sx={{
          backgroundColor: "#4F2C2D",
          backgroundSize: "cover",
          backgroundPosition: "right bottom",
        }}
      >
        <Grid container spacing={3} justifyContent="center">
          <Grid item xs={4} md={4}>
          </Grid>
          <Grid item xs={4} md={4}>
            <div class="mx-auto p-8 text-center">
              <Box sx={{ flex: 1, display: 'flex', justifyContent: 'center' }}>
                <img src="/pilot_logo_white.png" alt="Pilot Logo" width="170" height="52" />
              </Box>
            </div>
          </Grid>
          <Grid item xs={4} md={4}>
            <div class="max-w-lg mx-auto p-8 text-center">
              {roles &&
                roles.length > 0 &&
                roles.find(
                  (role) => role?.toLowerCase().includes("checkinappuser")
                    || role?.toLowerCase().includes("checkinappappuser")
                    || role?.toLowerCase().includes("checkinappadmin"))
                ?
                <>
                  <Button
                    sx={{ width: "32px" }}
                    onClick={() => {
                      localStorage.setItem('roles', "");
                      window.location.replace("/logout");
                      // localStorage.setItem('defaultEventId', "");
                    }}
                    title="Log out"
                  >
                    <LogoutIcon
                      style={{
                        color: "white",
                        fontSize: "2rem" // Adjust the size as needed
                      }}
                    />
                  </Button>
                  {/* {timeout && (
                    <Typography variant="body2" color="white" sx={{ marginLeft: 1 }}>
                      Time remaining {timeout}
                    </Typography>
                  )} */}
                </>
                :
                !IsNullOrEmpty(defaultEventId) &&
                <Box sx={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <Tooltip title="Home">
                    <Avatar sx={{ bgcolor: '#7f1d1d' }} variant="rounded" onClick={() => handleHome()}>
                      <button variant="contained" className="bg-[#7f1d1d] hover:bg-red-800 text-white rounded-full px-6 py-3 flex items-center justify-center space-x-2">
                        <HomeIcon  />
                      </button>
                    </Avatar>
                  </Tooltip>
                  <FormManagerLogin />
                  {/* {timeout && (
                    <Typography variant="body2" color="white" sx={{ marginLeft: 1 }}>
                      Time remaining {timeout}
                    </Typography>
                  )} */}
                </Box>
              }
            </div>
          </Grid>
        </Grid>
      </MobileAppBar >
    </>
  );
}
